export function Case1({onNext}) {
    const handleSubmit = (e) => {
        e.preventDefault();
        onNext();
    };

    return (
        <div className="texte">
            <div className="centered">
                <h5><b>Bienvenue dans l'espace</b></h5>
                <h5><b>« Garantie Franchise de Location »</b></h5>
            </div>
            <p>Pour compléter votre dossier, vous aurez besoin des éléments suivants :</p>
            <ul>
                <li>Le <b>contrat de location</b> souscrit ainsi que les conditions
                    d'assurance.
                </li>
                <li>L'<b>état descriptif</b> du départ et du retour du véhicule.</li>
                <li>Le <b>constat amiable ou une attestation sur l'honneur</b> des circonstances de l'accident ou, en cas de
                    vol, le dépôt de plainte auprès des autorités compétentes.
                </li>
                <li>Un <b>justificatif établi par le loueur</b> indiquant le montant des dommages et le montant acquitté resté
                    à votre charge, en application du contrat de location.
                </li>
                <li>Votre <b>Relevé d'Identité Bancaire</b> (RIB).</li>
            </ul>
            <p className="centered">Cliquez sur "SUIVANT" afin de finaliser votre demande.</p>
            <div className="app-buttons">
                <button className="buttons-primaire" onClick={handleSubmit}>Suivant</button>
            </div>
        </div>
    );
}
